import { render, staticRenderFns } from "./TipoValidacao.vue?vue&type=template&id=10fc711a&scoped=true"
import script from "./TipoValidacao.vue?vue&type=script&lang=js"
export * from "./TipoValidacao.vue?vue&type=script&lang=js"
import style0 from "./TipoValidacao.vue?vue&type=style&index=0&id=10fc711a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fc711a",
  null
  
)

export default component.exports